import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather'; // Import all icons

const ReportCount = (props) => {
  const { data = [] } = props;

  // Map of type to title, color, and icon
  const typeMapping = {
    0: { title: 'Idle', color: '#2cabe3', icon: <Icon.Slash size={18} /> },
    2: { title: 'Wrap Up', color: '#775dd0', icon: <Icon.CheckCircle size={18} /> },
    1: { title: 'On Call', color: '#008000', icon: <Icon.PhoneCall size={18} /> },
    4: { title: 'On Call', color: '#008000', icon: <Icon.PhoneForwarded size={18} /> },
    5: { title: 'Break', color: '#ffb22b', icon: <Icon.Coffee size={18} /> },
    6: { title: 'Dialing', color: '#800080', icon: <Icon.Volume2 size={18} /> },
    7: { title: 'Ringing', color: '#6376ff', icon: <Icon.Rss size={18} /> },
    8: { title: 'Dialing', color: '#800080', icon: <Icon.Volume2 size={18} /> },
    9: { title: 'Break', color: '#ffb22b', icon: <Icon.Coffee size={18} /> }
  };

  // Initialize all types with zero count
  const initialCounts = { 0: 0, 1: 0, 2: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0 };

  const counts = data.reduce((acc, item) => {
    if (acc[item.type] !== undefined) {
      acc[item.type] += parseInt(item.total_count);
    }
    return acc;
  }, initialCounts);

  // Combine On Call (type 1 + 4)
  const onCallCount = counts[1] + counts[4];
  delete counts[1];
  delete counts[4];

  // Combine Break (type 5 + 9)
  const breakCount = counts[5] + counts[9];
  delete counts[5];
  delete counts[9];

  // Combine Dialing (type 6 + 8)
  const dialingCount = counts[6] + counts[8];
  delete counts[6];
  delete counts[8];

  // Combine Ringing (type 7)
  const ringingCount = counts[7];
  delete counts[7];

  // Calculate the overall total count
  const overallTotalCount =
    Object.values(counts).reduce((acc, count) => acc + count, 0) +
    onCallCount +
    breakCount +
    dialingCount +
    ringingCount;

  return (
    <div className="report-container">
      <div className="d-flex justify-content-around align-items-center">
        {/* Total Count Card */}
        <div className="px-1" style={{ width: `${100 / 7}%` }}>
          <Card
            className="report-card px-2"
            style={{ borderBottom: `2px solid #122335`, background: '#12233533' }}>
            <div className="card-icon" style={{ backgroundColor: `#122335` }}>
              <div className="icon mr-2 fs-5" style={{ color: 'white' }}>
                <Icon.Phone size={18} />
              </div>
            </div>
            <div className="d-flex flex-column ps-2">
              <span className="fs-6">Total</span>
              <span className="fs-4">{overallTotalCount}</span>
            </div>
          </Card>
        </div>
        {/* Combined On Call Card */}
        {onCallCount > -1 && (
          <div className="px-1" style={{ width: `${100 / 7}%` }}>
            <Card
              className="report-card px-2"
              style={{ borderBottom: `2px solid #008000`, background: '#00800033' }}>
              <div className="card-icon" style={{ backgroundColor: `#008000` }}>
                <div className="icon mr-2 fs-5" style={{ color: 'white' }}>
                  <Icon.PhoneForwarded size={18} />
                </div>
              </div>
              <div className="d-flex flex-column ps-2">
                <span className="fs-6">On Call</span>
                <span className="fs-4">{onCallCount}</span>
              </div>
            </Card>
          </div>
        )}
        {Object.keys(counts).map((type) => {
          const { title, color, icon } = typeMapping[type];
          return (
            <div key={type} className="px-1" style={{ width: `${100 / 7}%` }}>
              <Card
                className="report-card px-2"
                style={{ borderBottom: `2px solid ${color}`, background: `${color}33` }}>
                <div className="card-icon" style={{ backgroundColor: `${color}` }}>
                  <div className="icon mr-2 fs-5" style={{ color: 'white' }}>
                    {icon}
                  </div>
                </div>
                <div className="d-flex flex-column ps-2">
                  <span className="fs-6">{title}</span>
                  <span className="fs-4">{counts[type]}</span>
                </div>
              </Card>
            </div>
          );
        })}

        {/* Combined Break Card */}
        {breakCount > -1 && (
          <div className="px-1" style={{ width: `${100 / 7}%` }}>
            <Card
              className="report-card px-2"
              style={{ borderBottom: `2px solid #ffb22b`, background: '#ffb22b33' }}>
              <div className="card-icon" style={{ backgroundColor: `#ffb22b` }}>
                <div className="icon mr-2 fs-5" style={{ color: 'white' }}>
                  <Icon.Coffee size={18} />
                </div>
              </div>
              <div className="d-flex flex-column ps-2">
                <span className="fs-6">Break</span>
                <span className="fs-4">{breakCount}</span>
              </div>
            </Card>
          </div>
        )}

        {/* Combined Dialing Card */}
        {dialingCount > -1 && (
          <div className="px-1" style={{ width: `${100 / 7}%` }}>
            <Card
              className="report-card px-2"
              style={{ borderBottom: `2px solid #800080`, background: '#80008033' }}>
              <div className="card-icon" style={{ backgroundColor: `#800080` }}>
                <div className="icon mr-2 fs-5" style={{ color: 'white' }}>
                  <Icon.Volume2 size={18} />
                </div>
              </div>
              <div className="d-flex flex-column ps-2">
                <span className="fs-6">Dialing</span>
                <span className="fs-4">{dialingCount}</span>
              </div>
            </Card>
          </div>
        )}
        {/* Combined Ringing Card */}
        {ringingCount > -1 && (
          <div className="px-1" style={{ width: `${100 / 7}%` }}>
            <Card
              className="report-card px-2"
              style={{ borderBottom: `2px solid #6376ff`, background: '#6376ff33' }}>
              <div className="card-icon" style={{ backgroundColor: `#6376ff` }}>
                <div className="icon mr-2 fs-5" style={{ color: 'white' }}>
                  <Icon.Rss size={18} />
                </div>
              </div>
              <div className="d-flex flex-column ps-2">
                <span className="fs-6">Ringing</span>
                <span className="fs-4">{ringingCount}</span>
              </div>
            </Card>
          </div>
        )}
      </div>
    </div>
  );
};

ReportCount.propTypes = { data: PropTypes.array.isRequired };

export default ReportCount;
